import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { headerScreenOptions } from "../../components/HeaderBackButton";
import { ParamList } from "./types";
import DuesSummaryScreen from "./DuesSummaryScreen";
import DuesOverviewScreen from "./DuesOverviewScreen";
import AssignProxyScreen from "./AssignProxyScreen";
import { ScreenProps } from "../types";

const Stack = createNativeStackNavigator<ParamList>();

export default function DuesScreen({ route }: ScreenProps<"Dues">) {
  const { assignProxy } = route.params || {};

  return (
    <Stack.Navigator id="Dues" screenOptions={headerScreenOptions}>
      <Stack.Screen
        name={assignProxy ? "DuesProxyOverview" : "DuesOverview"}
        component={DuesOverviewScreen}
        options={{ title: "Dues Payment" }}
      />
      <Stack.Screen name="AssignProxy" component={AssignProxyScreen} options={{ title: "Assign Proxy" }} />
      <Stack.Screen name="DuesSummary" component={DuesSummaryScreen} options={{ title: "Dues Summary" }} />
    </Stack.Navigator>
  );
}
